
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" className="text-2xl font-bold text-emerald-600 cursor-pointer" style={{ fontFamily: '"Pacifico", serif' }}>
              SERVDFRESH
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Home
            </a>
            <a href="/chefs" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Find Chefs
            </a>
            <a href="/about" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              About
            </a>
            <a href="/contact" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
              Contact
            </a>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex space-x-3">
            <a
              href="/list-business"
              className="border border-emerald-600 text-emerald-600 px-4 py-2 rounded-lg hover:bg-emerald-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              List Your Business
            </a>
            <a
              href="/chefs"
              className="bg-emerald-600 text-white px-6 py-2 rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Chef
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer"
            >
              <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <a href="/" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                Home
              </a>
              <a href="/chefs" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                Find Chefs
              </a>
              <a href="/about" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                About
              </a>
              <a href="/contact" className="text-gray-700 hover:text-emerald-600 transition-colors cursor-pointer">
                Contact
              </a>
              <a
                href="/list-business"
                className="border border-emerald-600 text-emerald-600 px-6 py-2 rounded-lg hover:bg-emerald-50 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                List Your Business
              </a>
              <a
                href="/chefs"
                className="bg-emerald-600 text-white px-6 py-2 rounded-lg hover:bg-emerald-700 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                Book a Chef
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
